<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center vx-card" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <form @submit.prevent="onSubmit">
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto" />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">Nitro Dashboard</h4>
                  <p>Kullanıcı bilgilerinizi giriniz.</p>
                </div>
                <vs-input v-if="!loginWithSms" name="mail" icon="icon icon-user" icon-pack="feather" label-placeholder="Eposta" v-model="mail" class="w-full no-icon-border" />

                <vs-input v-if="!loginWithSms" type="password" name="password" icon="icon icon-lock" icon-pack="feather" label-placeholder="Şifre" v-model="password" class="w-full mt-6 no-icon-border" />

                <vs-input v-if="loginWithSms" type="number" name="smsCode" label-placeholder="SMS Kod" v-model="loginSmsCode" class="w-full mt-6 no-icon-border" />

                <div class="flex flex-wrap justify-between my-5">
                  <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Beni Hatırla</vs-checkbox>
                  <router-link to="/resetpassword">Forgot Password?</router-link>
                </div>

                <vs-button v-if="loginResult.loginAction != 'BlockIpAddress'" class="float-right">Giriş</vs-button>

                <vs-divider>www.nitrobilisim.com.tr</vs-divider>
                <vs-alert v-show="errorShow" title="Uyarı" color="danger"> Kullanıcı adı - şifreniz veya SMS kodu hatalı! {{ loginResult.loginAction }}</vs-alert>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { router } from "@/router";
import { authenticationService } from "../../_services/authentication.service";
import { repository } from "../../_services/repository";
import { normalizeUnits } from "moment";

export default {
  data() {
    return {
      loginResult: { loginAction: "AllowLogin" },
      errorShow: false,
      checkbox_remember_me: false,
      mail: "",
      password: "",
      loginSmsCode: null,
      loginWithSms: false,
    };
  },
  created() {
    this.$vs.loading.close();
    //clear previous timers
    if (Array.isArray(navigator.timers))
      for (let i = 0; i < navigator.timers.length; i++) {
        clearInterval(navigator.timers[i].timer);
      }
    // redirect to home if already logged in
    this.returnUrl = this.$route.query.returnUrl || "/";
    console.log(this.returnUrl);
    if (authenticationService.validateState()) {
      //return router.push(this.returnUrl);
      return router.push("/");
    }

    // get return url from route parameters or default to '/'
  },
  methods: {
    onSubmit: async function() {
      //   authenticationService
      //     .login(this.mail, this.password)
      //     .then(
      //       // eslint-disable-next-line
      //       (user) => router.push(this.returnUrl),
      //       (error) => {
      //         this.error = error;
      //         this.ErrorShow = true;
      //       }
      //     )
      //     .catch((e) => {
      //       console.warn("login error", e);
      //       this.ErrorShow = true;
      //     });
      // },

      this.loginResult = await authenticationService.login(this.mail, this.password, this.loginSmsCode);

      if (this.loginResult != null) {
        if (this.loginResult.loginAction == "SmsRequiredForLoginSMSSended") {
          this.errorShow = false;
          this.loginWithSms = true;
        } else if (this.loginResult.loginAction == "LoginSuccesful") {
          this.errorShow = false;
          //router.push(this.returnUrl);
          router.push("/");
        } else {
          this.errorShow = true;
        }
      } else {
        this.errorShow = true;
        this.loginResult = { loginAction: "Hatalı parametre" };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#page-login {
  .social-login {
    .bg-facebook {
      background-color: #1551b1;
    }

    .bg-twitter {
      background-color: #00aaff;
    }

    .bg-google {
      background-color: #4285f4;
    }

    .bg-github {
      background-color: #333;
    }
  }
}
</style>
